import type {Base64Object} from '@cp/model';
import {useCallback} from 'react';
import {flashcardCreateByCsv} from '../api/callable/flashcardCreateByCsv';
import {useFunctionWrap} from './helper/function/useFunctionWrap';

export default function useCreateFlashcardByCsv() {
  const createFlashcardByCsvFn = useCallback(async (csvFile: Base64Object, title: string) => {
    return await flashcardCreateByCsv({csvFile, title});
  }, []);
  const {fn: createFlashcardByCsv, loading, error} = useFunctionWrap(createFlashcardByCsvFn);

  return {createFlashcardByCsv, loading, error};
}
